import { StarRatingContainer } from '../../containers/filters/StarRatingContainer';
import { EFilterType, IFilter } from '../../types/filters';

export const starRating: IFilter = {
  component: StarRatingContainer,
  type: EFilterType.Openable,
};
